// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared inline error banner used by the registration form and its steps.
   Consumers pull these in with \`composes: inlineError from './errorBanner.module.css'\`. */
.errorBanner_inlineError__XdOeV {
  background-color: #fff5f5;
  border: 1px solid #feb2b2;
  color: #c53030;
  padding: 12px 40px 12px 16px;
  border-radius: 8px;
  margin-bottom: 25px;
  position: relative;
  font-size: 0.95rem;
  line-height: 1.4;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.errorBanner_inlineErrorClose__gRhf8 {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1;
  color: #fc8181;
  transition: color 0.2s ease;
  padding: 4px;
}

.errorBanner_inlineErrorClose__gRhf8:hover {
  color: #c53030;
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/errorBanner.module.css"],"names":[],"mappings":"AAAA;0FAC0F;AAC1F;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Shared inline error banner used by the registration form and its steps.\n   Consumers pull these in with `composes: inlineError from './errorBanner.module.css'`. */\n.inlineError {\n  background-color: #fff5f5;\n  border: 1px solid #feb2b2;\n  color: #c53030;\n  padding: 12px 40px 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 25px;\n  position: relative;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.inlineErrorClose {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: #fc8181;\n  transition: color 0.2s ease;\n  padding: 4px;\n}\n\n.inlineErrorClose:hover {\n  color: #c53030;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineError": `errorBanner_inlineError__XdOeV`,
	"inlineErrorClose": `errorBanner_inlineErrorClose__gRhf8`
};
export default ___CSS_LOADER_EXPORT___;
